import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const getRequirementDefinition = async (
  id: string
): Promise<IRequirementDefinitionResponse> => {
  const response = await servicePayments.get(`/requirement-definition/${id}`);
  return response.data;
};
